<template>
  <div>
    <div class="content">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="我的考试" name="first"></el-tab-pane>
        <el-tab-pane label="我的学习" name="second"></el-tab-pane>
      </el-tabs>
      <el-table :data="tableData"
        style="width: 100%">
        <el-table-column prop="number" label="考试编号"></el-table-column>
        <el-table-column prop="examName" label="考试名称"></el-table-column>
        <el-table-column prop="startTime" label="考试开始时间"></el-table-column>
        <el-table-column prop="endTime" label="考试结束时间"></el-table-column>
        <el-table-column prop="score" label="得分"></el-table-column>
        <el-table-column prop="totalPoints" label="总分"></el-table-column>
        <el-table-column prop="answerStatus" label="是否答题">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.answerStatus == 0" type="danger">未答题</el-tag>
            <el-tag v-if="scope.row.answerStatus == 1">已答题</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="pass" label="是否通过">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.pass == 0" type="danger">未通过</el-tag>
            <el-tag v-if="scope.row.pass == 1">通过</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-link type="danger" size="small" @click.native.prevent="deleteData(scope.row)">删除 </el-link>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: right; margin-top: 10px">
        <Page :total="total" :page-size="pageSize" @on-change="getData" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: 'first',
      tableData: [],
      fileNameOrTag: '',
      pageSize: 10,
      currentPage: 1,
      form: {},
      total: 0,
      pageTotal: 0
    }
  },
  methods: {
    handleClick(row) {
      this.activeName = row.name
      this.currentPage = 1
      this.getData(this.currentPage)
    },
    add: function() {
      this.$router.push({
        path: '/processManager/addQuestion'
      })
    },
    deleteData: function(row) {
      this.componentsMoudel.httpRequest
        .getRequestHander('/cultivateHistory/deleteHistory/' + row.id)
        .openLoad()
        .startPost()
        .then(res => {
          this.$message({
            showClose: true,
            message: '删除成功',
            type: 'success'
          })
          this.getData(this.currentPage)
        })
    },
    getData(page) {
      // let param = {}
      // param.limit = this.pageSize
      // param.curPage = page
      // param.fileNameOrTag = this.fileNameOrTag
      // param.examType = this.activeName === 'first' ? 0 : 1
      let param = new FormData()
      param.append('limit', this.pageSize)
      param.append('curPage', page)
      param.append('examType', this.activeName === 'first' ? 0 : 1)
      this.componentsMoudel.httpRequest
        .getRequestHander('/appExamination/userFindExamPageList')
        .openLoad()
        .startPost(param)
        .then(res => {
          this.tableData = res.body.data
          // for (var i = 0; i < this.tableData.length; i++) {
          //   var argument = this.tableData[i]
          //   let num = this.tableData[i].questionnaireVo.questionBankVos.length
          //   this.tableData[i].num = num
          // }
          this.currentPage = res.body.page
          this.total = res.body.cum
        })
    },
    handleSizeChange(val) {
      this.pageSize = val
    },
    handleCurrentChange(val) {
      this.currentPage = val
    }
  },
  mounted: function() {
    this.getData(1)
  },
  created() {}
}
</script>

<style scoped>
.myHead {
  position: absolute;
  top: 0px;
  left: 250px;
  width: 80%;
  height: 60px;
}
</style>
